import { EffectCallback, useEffect, useRef } from "react";

/**
 * Util hook that will run only once unless the callback effect is changed
 *
 * @param effect — Imperative function that can return a cleanup function
 */

const useOnce = (effect: EffectCallback) => {
  const ref = useRef(false);

  useEffect(() => {
    if (!ref.current) {
      effect();
    }
    ref.current = true;
  }, [effect]);
};

export default useOnce;
